import { FONT_FAMILY } from '@utils/constants';

export const ANNOTATION_SERIES = 'annotation-series';

export const markLineOptions = (data) => {
  return {
    symbol: [
      "none",
      "circle"
    ],
    lineStyle: {
      width: 1,
      type: "solid",
      color: "#666666"
    },
    label: {
      show: false,
    },
    emphasis: {
      disabled: true,
    },
    tooltip: {
      trigger: "item",
      borderWidth: 0,
      textStyle: {
        fontFamily: FONT_FAMILY,
        width: 100,
        height: 40,
        fontSize: 12,
        overflow: 'break',
        shadowBlur: 10,
        shadowColor: "rgba(0, 0, 0, .2)",
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        borderRadius: 4,
      },
      formatter: ({ data }) => {
        return data.info.title.replace(' | ', '<br/>') + ' <br/> '
          + `<i style="color: #4a4a4a; font-size: 14px;">${data.info.comment}</i>`;
      }
    },
    "data": data,
  };
}

export const getAnnotationOption = (metricAnnotations, params = {}) => {
  return {
    id: ANNOTATION_SERIES,
    name: 'Annotations',
    type: 'line',
    markLine: markLineOptions(metricAnnotations),
    xAxisIndex: 0,
    yAxisIndex: 0,
    ...params,
  };
}
